import React, { Children } from 'react';
import { Footer } from '../components/Footer';
export const Privacy = () => {
  return <div className="flex flex-col min-h-screen" data-id="element-567" data-mp="2wk6wfj0w7vc2">
      <main className="py-16 md:py-24 relative flex-grow overflow-hidden" data-id="element-568" data-mp="2wlhzfgmikz24">
        {/* Background pattern - now using relative positioning */}
        <div className="absolute inset-0 bg-grid-gray-900/[0.02] -z-10" data-id="element-569" data-mp="36hbaevkl4khs" />
        {/* XL Cyan gradient blob */}
        <div className="absolute -left-[300px] top-[10%] w-[1400px] h-[1400px] bg-gradient-to-tr from-cyan-500/15 via-primary-300/10 to-cyan-200/15 rounded-[50%_50%_45%_55%] blur-3xl -z-10" data-id="element-570" data-mp="3k8gfweamw701" />
        {/* Background gradient blobs - contained within main content */}
        <div className="absolute top-0 right-1/3 w-[900px] h-[900px] bg-gradient-to-br from-cyan-400/10 via-cyan-400/10 to-blue-400/10 rounded-[60%_40%_55%_45%] blur-3xl -z-10" data-id="element-571" data-mp="3p8cjicff5wf2" />
        <div className="absolute top-[30%] -left-[200px] w-[800px] h-[800px] bg-gradient-to-tr from-purple-400/10 via-violet-400/10 to-fuchsia-400/10 rounded-[40%_60%_45%_55%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-572" data-mp="1zvikn4frt4b3" />
        <div className="absolute top-[60%] right-0 w-[750px] h-[750px] bg-gradient-to-bl from-amber-400/10 via-orange-400/10 to-red-400/10 rounded-[55%_45%_60%_40%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '1.5s'
      }} data-id="element-573" data-mp="l4sxmf6gbeaf" />
        <div className="absolute bottom-0 left-1/4 w-[700px] h-[700px] bg-gradient-to-r from-emerald-400/10 via-green-400/10 to-cyan-400/10 rounded-[45%_55%_50%_50%] blur-3xl -z-10 animate-float" style={{
        animationDelay: '3s'
      }} data-id="element-574" data-mp="uvnl1mvfojxg" />
        {/* Content container */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-575" data-mp="18tvc5e5sgr0p">
          <h1 className="text-4xl md:text-5xl font-serif font-normal text-cyan-900 mb-6 text-center" data-id="element-576" data-mp="1drdl34jt368p">
            Privacy Policy
          </h1>
          <div className="prose prose-lg max-w-none bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-sm border border-gray-100" data-id="element-577" data-mp="3an317fb7emzs">
            <p className="text-gray-500 mb-8" data-id="element-578" data-mp="motadl4v4jbj">Last Updated: June 2026</p>

            <p className="mb-6 text-gray-700" data-id="element-579" data-mp="hq88lh9yprkz">
              At Teaching Lab Ventures, Inc. ("TLVI", "we", "our", "us"),
              privacy is important to us. This Privacy Policy describes how TLVI
              collects personally identifiable information ("PII") via the Site
              and Services, as such terms are defined in the End User License
              Agreement.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-580" data-mp="10p42ssltm5yt">
              This Privacy Policy does not apply to the information that our
              business partners, including our network of foundations,
              districts, schools, coaches, and teachers, choose to manage,
              upload, and store in our Services ("Partner Content") for which we
              are a service provider/processor. In those circumstances, we
              process and/or host Partner Content on behalf of a business
              partner and that business partner is responsible for the
              collection and use of all Partner Content, including all necessary
              consents related to such Partner Content. The respective business
              partner's privacy notice will apply to the business partner's
              collection and use of such Partner Content and questions regarding
              such notice should be directed to such business partner.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-581" data-mp="1k8t5mxljf7sm">
              By accessing or using the Website and Services or otherwise
              providing personal information to us via the Website and Services
              and contact us methods, you have consented to the terms of this
              Privacy Policy and consent to our privacy practices described
              herein, including our use and disclosure of your personal
              information. If you do not agree to the terms and conditions of
              this Privacy Policy, then please do not provide us with your
              personal information and do not access or use the Website and
              Services. Please note that if you choose to limit the information
              that you provide to us while using the Website and Services, you
              may not be able to use or participate in certain features of the
              Website and Services. If you have additional questions or require
              more information about our Privacy Policy, do not hesitate to
              contact us.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-582" data-mp="ajjd2v9qazq8">
              Information We Collect
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-583" data-mp="5nkszjvfo3vm">
              As further described below, we collect personal information
              directly from you, automatically through your use of the Website
              and Services, and from other, third-party sources. To the extent
              permitted by applicable law, we may combine the information we
              collect from you with publicly available or data we receive from a
              third party.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-584" data-mp="27hgxalb6g8b7">
              <span className="font-semibold" data-id="element-585" data-mp="2c9ib4bnzu73c">
                Personal Information We Collect Directly From You.
              </span>{' '}
              While the personal information we collect varies depending upon
              your use of the Website, Services, and our interactions with you,
              in general, we collect the following personal information directly
              from you:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-586" data-mp="1tih9ffvhnxg3">
              <span className="font-semibold" data-id="element-587" data-mp="1tlve4urmkiqp">Contact Information.</span> When
              you contact us, we collect your name, email address, phone number,
              and other contact information you choose to provide.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-588" data-mp="39wzao1vusri4">
              <span className="font-semibold" data-id="element-589" data-mp="39zvaxwv6bs9q">Employment Information.</span>{' '}
              When you contact us, we collect information regarding the school
              or organization with whom you are associated.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-590" data-mp="2u8cgnp99x4yi">
              <span className="font-semibold" data-id="element-591" data-mp="2u71c3n807t6c">
                Account Registration Information.
              </span>{' '}
              When you register for an account in the Services, we collect
              information on you in order to set up such an accountsuch account.
              This may include your name, email address, phone number, school or
              organization name, job title, location information including
              state/province and country, login name and password.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-592" data-mp="26gdqjz56151b">
              <span className="font-semibold" data-id="element-593" data-mp="1irulrtlbradz">
                Classroom Recordings (if applicable).
              </span>{' '}
              If your organization has enabled our Video Coaching feature, the
              Coaching Capture app records classroom teaching sessions so that
              teaching practice can be reviewed and coached. These recordings
              include video, audio, and transcripts, and may incidentally
              capture students' images and voices. We treat this content as
              personally identifiable information and use it solely to provide
              coaching (not to train AI models or for advertising), and limit
              access to authorized teachers, coaches, and leaders. This content
              is Partner Content, and your organization is responsible for
              obtaining any necessary consents.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-594" data-mp="72dr8p161w2t">
              <span className="font-semibold" data-id="element-595" data-mp="713v45dvixyt">
                Payment Information (if applicable).
              </span>{' '}
              You may be required to provide financial and bank information
              prior to purchasing the Services. Please note, we do not store
              financial and bank information; such information is securely
              processed and stored by our payment processor. For more
              information regarding the payment processor's privacy practices,
              please review the policies provided by such provider.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-596" data-mp="35iir7ymp4nki">
              <span className="font-semibold" data-id="element-597" data-mp="61kslt4ruaml">
                Communications and Interactions.
              </span>{' '}
              When you send email, call, or otherwise communicate with us and
              with members of our team, we collect and maintain a record of your
              contact details, communications, and our responses.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-598" data-mp="3ofjyxr7mx1s5">
              <span className="font-semibold" data-id="element-599" data-mp="pqbotlz7xz4k">Responses and Feedback.</span> If
              you participate in our surveys or questionnaires, we collect your
              responses and feedback, such as user satisfaction or other
              information related to your use of the Website and Services, and
              any other information you so choose to provide.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-600" data-mp="128npzxyp27jn">
              <span className="font-semibold" data-id="element-601" data-mp="126uk4kvwnrcp">Marketing and Promotions.</span>{' '}
              We collect your email, name, phone number, preferences. If you
              participate in promotions we offer, we collect your name and other
              information related to the activities available through the
              Website and Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-602" data-mp="1kynccd35h8jd">
              <span className="font-semibold" data-id="element-603" data-mp="1kzox599yx9ea">Preferences.</span> We also may
              collect information about your preferences, including
              communications preferences.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-604" data-mp="1txijbre0qmnq">
              The Services are designed to assist education professionals. While
              using the Services, you may upload teaching or coaching-related
              materials or interact with chat features. Please do not upload any
              personal information, including but not limited to student names,
              identification numbers, contact information, or any other data
              that could be used to identify an individual student. The Services
              are intended for use with de-identified or anonymized content
              only; they cannot be used to identify any individual student.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-605" data-mp="2f5rvhsu9oxde">
              By using the Services, you agree not to input, store, or transmit
              any personal information or sensitive data. We are not responsible
              for any personal information that is uploaded in violation of this
              policy.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-606" data-mp="urrk963mdcnb">
              <strong data-id="element-607" data-mp="uskghd4ycjr7">Personal Information We Collect Automatically.</strong> We
              and our third-party providers automatically collect personal
              information related to your use of the Website and Services,
              including using cookies and other similar technologies. The
              personal data we may automatically collect includes the below
              categories of information (collective, "Usage Data"):
            </p>
            <p className="mb-2 text-gray-700" data-id="element-608" data-mp="3r0n2pnqy7cp5">
              <strong data-id="element-609" data-mp="3r0ddw3hn3bl1">Device and Browsing Information.</strong> When you visit
              the Website and Services, we may collect IP address, browser type,
              domain names, access times, date/time stamps, operating system,
              language, device type, unique ID, Internet service provider,
              referring and exiting URLs, clickstream data, and similar device
              and browsing information.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-610" data-mp="21m8j1huseg0i">
              <strong data-id="element-611" data-mp="21kdwy07s4huu">Activities and Usage.</strong> We also collect activity
              information related to your use of the Website and Services, such
              as information about the links clicked, searches, features used,
              items viewed, time spent within the Website, your interactions
              with us within the Website and Services, and other activity and
              usage information.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-612" data-mp="1kcmq9zq7cu6w">
              <strong data-id="element-613" data-mp="1kbutwmos6sfk">Location Information.</strong> We may also collect or
              derive location information about you, such as through your IP
              address. If you choose to enable location-based sharing with us
              through your device settings, we may collect precise location
              information to provide content that is more relevant to your
              location and to otherwise improve your interactions with the
              Website and Services. You may turn off location data sharing
              through your device settings.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-614" data-mp="ms4ql3cpol6t">
              For more information about our use of cookies and other similar
              technologies, please see the "COOKIES AND OTHER TECHNOLOGIES"
              section below.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-615" data-mp="wn6ha3mmxvbi">
              <strong data-id="element-616" data-mp="rpwpwifor9l1">
                Personal Information We Collect from Other Sources.
              </strong>{' '}
              In addition, we may collect and receive certain personal
              information from business partners, organizations, and public
              databases. As permitted by applicable law, we may combine this
              information with other personal information within our possession
              and will use it in accordance with the Privacy Policy.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-617" data-mp="1ohguk6xstz3l">
              Some of our Services allow you to provide us with personal
              information relating to other parties (collectively, "Third-Party
              Data"). If you use any feature of the Services that allows you to
              communicate with other parties (such as to refer another other
              party to the Services or to communicate with them), either by
              submitting Third-Party Data to the Services or otherwise
              permitting the Services to automatically access Third-Party Data
              in your possession, you acknowledge, represent, and agree (a) that
              you have the authority of the relevant other party for us to
              access and use the relevant Third-Party Data, and (b) that you
              have notified these other parties and informed them how their
              information is collected and used by us to provide the Services.
              We reserve the right to identify you as the person who has made
              the referral in any messages that are sent to other parties. We
              use Third-Party Data to (a) contact such party using the
              Third-Party Data provided, and/or (b) provide you with an editable
              template message designed to facilitate communication between you
              and such party through the Services. We may also send reminders or
              related messages to you and to other parties on your behalf from
              time to time, as and where permitted by applicable law.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-618" data-mp="1q0l3pktl7i36">
              How We Use Your Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-619" data-mp="1l2tbepp15tyg">
              We use the personal information we collect in various ways,
              including to:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-620" data-mp="1c124jhir7h30">
              <strong data-id="element-621" data-mp="1c2dbfq7hx4yc">To Provide the Website and Services:</strong> To operate,
              deliver, and maintain the Website and Services and any other
              services you may request from us.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-622" data-mp="3piwthqnqedso">
              <strong data-id="element-623" data-mp="3ph3oefsro1ms">To Monitor and Maintain the Website and Services:</strong>{' '}
              To monitor system performance, diagnose issues, administer and
              troubleshoot the Website and Services, analyze trends and usage
              patterns, and generate statistics.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-624" data-mp="3lhl51oglfym2">
              <strong data-id="element-625" data-mp="d1javfibfdsr">To Respond to Your Requests:</strong> To answer your
              questions, fulfill your requests, and provide customer support.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-626" data-mp="h0qwz477d217">
              <strong data-id="element-627" data-mp="33vaa8y13c2o">To Communicate with You:</strong> We may send you
              marketing communications about the Services, promotions, and other
              information that may be of interest to you.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-628" data-mp="2nrq3t6jjt3qr">
              <strong data-id="element-629" data-mp="2ss4det0sslqw">To Use Third-Party Data You Provide:</strong> If you
              provide information about third parties (such as to contact those
              third parties), we may use that information to facilitate
              communication, send reminders, and support other related features,
              as allowed by applicable law.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-630" data-mp="2u8rw7bdw441n">
              <strong data-id="element-631" data-mp="2p9ylfqpzmr56">To Improve the Services:</strong> We may use your personal
              information to make the Services more stable and user-friendly,
              analyze service issues, improve the design and content of the
              Services, analyze how the Services are used, offer new services,
              and develop new Services and programs relating to the Services.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-632" data-mp="26jqjhby0y6qk">
              <strong data-id="element-633" data-mp="26hvxdub0o8kw">For Marketing and Audience Engagement:</strong> To analyze
              user engagement and improve how we communicate with users.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-634" data-mp="1dujmwii4rr7y">
              <strong data-id="element-635" data-mp="t9hkd2usvisg">To Provide Customer Service and Notices:</strong> To
              respond to your feedback and send administrative updates, legal
              notices, or changes to this Privacy Policy or our Terms.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-636" data-mp="129wgkx9ayiaq">
              <strong data-id="element-637" data-mp="12c8w73rl8gkm">To Support Business Operations:</strong> For internal uses
              such as audits, market research, analytics, security, and
              performance monitoring.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-638" data-mp="1c6j27o9gdddt">
              <strong data-id="element-639" data-mp="1g8vwngir1ova">To Enforce Our Agreements:</strong> To uphold our Terms,
              this Privacy Policy, and any other agreements between you and us.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-640" data-mp="1pzh3tscho1pt">
              <strong data-id="element-641" data-mp="1pz8sw5zxf6h9">To Promote Safety and Prevent Fraud:</strong> To help
              protect the security of the Services and users by detecting,
              preventing, and responding to fraud, abuse, unauthorized access,
              and other security-related issues.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-642" data-mp="3khjw5mr47go7">
              <strong data-id="element-643" data-mp="3fgvy4h4gxzkh">For Other Legitimate Purposes:</strong> Including:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-1" data-id="element-644" data-mp="3fj8l58p3304e">
              <li data-id="element-645" data-mp="3ai1exe2la8zu">
                Any other purpose for which you provide personal information;
              </li>
              <li data-id="element-646" data-mp="35ksraxyo9cr7">
                Compliance with internal policies or legal/regulatory
                obligations;
              </li>
              <li data-id="element-647" data-mp="21g37pikp1t1">Any other use disclosed at the time of collection;</li>
              <li data-id="element-648" data-mp="3tgnfmru71y38">Any use with your consent;</li>
              <li data-id="element-649" data-mp="3tfcd0vchiwdp">Any other purpose described in this Privacy Policy.</li>
            </ul>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-650" data-mp="3ogiyczlgozby">
              How We Disclose Your Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-651" data-mp="psv89q1qhx7z">
              Targeted or Personalized advertising (ads based on a user's
              personal information) is not used or displayed in the Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-652" data-mp="2bjbfgevjamc9">
              We may share your personal information for the purposes described
              above and as follows:
            </p>
            <p className="mb-2 text-gray-700" data-id="element-653" data-mp="22l9jweukklwd">
              <strong data-id="element-654" data-mp="1xmg2wcg2qcrg">Affiliates, Subsidiaries, and Sponsors.</strong> We may
              disclose the personal information we collect to our corporate
              affiliates and subsidiaries and sponsors.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-655" data-mp="2qbn27dncr6dr">
              <strong data-id="element-656" data-mp="2qcy6rfomgi5x">Vendors and Service Providers.</strong> We disclose the
              personal information we collect to service providers who perform
              functions on our behalf, such as regulatory compliance services,
              AI vendors, IT and website hosting, marketing, customer support,
              data storage, analysis and processing providers. For the current
              list of these providers and the data each one handles, see our{' '}
              <a href="/sub-processors" className="text-cyan-700 hover:text-cyan-800 underline underline-offset-2" data-id="element-657" data-mp="3gmfdfae5cd39">
                sub-processors list
              </a>
              .
            </p>
            <p className="mb-2 text-gray-700" data-id="element-658" data-mp="3qhh2y7cc3h6d">
              <strong data-id="element-659" data-mp="3ukvikwwd1vja">
                Foundations, Schools, Teachers, and Others at your direction.
              </strong>{' '}
              We disclose the personal information we collect to foundations,
              schools, teachers, and other educational partners with your
              consent and at your direction.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-660" data-mp="d4dxsf2fty2j">
              <strong data-id="element-661" data-mp="i2p78ootm6k8">Marketing and Analytics Providers.</strong> We may
              disclose your personal information, including your Usage Data, to
              marketing networks, data analytics providers, and other companies
              who provide marketing or analytics services on our behalf.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-662" data-mp="2n60allrzderb">
              <strong data-id="element-663" data-mp="2n4p6tlyjc707">In Support of Business Transfers.</strong> If we or our
              affiliates are or may be acquired by, merged with, or invested in
              by another company, or if any of our assets are or may be
              transferred to another company, whether as part of a bankruptcy or
              insolvency proceeding or otherwise, we may disclose or transfer
              the personal information we have collected from you with or to the
              other company. We may disclose certain personal information as
              necessary prior to the completion of such a transaction or other
              corporate transactions such as a financing or restructuring, to
              lenders, auditors, and third-party advisors, including attorneys
              and consultants.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-664" data-mp="1gil5ro9lobi8">
              <strong data-id="element-665" data-mp="1gjw9jo31pj9c">Compliance and Legal Obligations.</strong> To comply with
              our legal and compliance obligations and to respond to the legal
              process. For example, we may disclose information in response to
              subpoenas, court orders, and other lawful requests by regulators
              and law enforcement, including responding to national security or
              law enforcement disclosure requirements.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-666" data-mp="39enq8e8rnerj">
              <strong data-id="element-667" data-mp="39dvzbgq4657l">With our Professional Advisors.</strong> We share your
              personal information with our attorneys, auditors, and other
              professional advisors who are providing you or assisting us in
              providing you with the services, to comply with applicable legal
              and regulatory requirements, and to support us with the purposes
              described in this Privacy Policy.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-668" data-mp="12p9479sxnhmn">
              <strong data-id="element-669" data-mp="12ny1zef4yhxn">Security and Protection of Rights.</strong> Where we
              believe doing so is necessary to protect us, our rights and our
              property, or the rights, property, and safety of others.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-670" data-mp="3znh0cbd6d8c">
              <strong data-id="element-671" data-mp="3yce0epqt9ia">Aggregate and Deidentified Information.</strong>{' '}
              Notwithstanding anything else in this Privacy Policy, we may use,
              disclose, and otherwise process aggregate and deidentified
              information related to our business and the Website and Services
              in accordance with applicable law.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-672" data-mp="3he0nd2netkn1">
              <strong data-id="element-673" data-mp="3hcpjl2tyscvx">Other Disclosures.</strong> We may disclose personal
              information in other ways not described above, but will notify you
              and, if necessary, obtain your consent for any such disclosures
              that are not otherwise described above.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-674" data-mp="33h57aq8qqsxh">
              Cookies And Other Technologies
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-675" data-mp="1my25ya53o4yf">
              Like many other websites, we and our third-party providers use
              cookies, pixel tags, and other technologies to collect Usage Data.
              We may allow third parties to collect this Usage Data on our
              behalf and to retain and use this Usage Data themselves. We use
              this Usage Data to, for example, analyze and understand how you
              access, use, and interact with us through the Website and
              Services, to identify and resolve bugs and errors in the Website
              and Services, to assess, secure, protect, optimize, and improve
              the performance of the Website and Services, for marketing
              purposes, analytics purposes, and to personalize content on the
              Website.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-676" data-mp="lfrk8b577o5c">
              <strong data-id="element-677" data-mp="dgeja3qpzhy8">Third Party Analytics.</strong> We use third party tools
              which are operated by third party companies to analyze ad traffic
              and usage of the Website. This data may be used for purposes
              including delivering banner advertisements and other advertising
              tailored to your interests when you visit certain websites.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-678" data-mp="3qmwwccbl8gla">
              <strong data-id="element-679" data-mp="3qnq157qzkw0s">Google Analytics.</strong> We use Google Analytics on the
              Website to help us analyze traffic and improve services. For more
              information on Google Analytics' processing of personal
              information, please see{' '}
              <a href="https://www.google.com/policies/privacy/partners/" className="text-primary-600 hover:text-primary-800" data-id="element-680" data-mp="3vlrm5y7z35ew">
                https://www.google.com/policies/privacy/partners/
              </a>
              . You may opt out of the use of Google Analytics here:{' '}
              <a href="https://tools.google.com/dlpage/gaoptout" className="text-primary-600 hover:text-primary-800" data-id="element-681" data-mp="2stnotyoirdso">
                https://tools.google.com/dlpage/gaoptout
              </a>
              .
            </p>
            <p className="mb-2 text-gray-700" data-id="element-682" data-mp="2jutlzqklhr6o">
              <strong data-id="element-683" data-mp="2os27a011ibc5">PostHog.</strong> We use PostHog Analytics on the Website
              and Services to help us analyze traffic and improve services. For
              more information on PostHog's processing of personal information,
              please see{' '}
              <a href="https://posthog.com/web-analytics" className="text-primary-600 hover:text-primary-800" data-id="element-684" data-mp="3glm4euv03vbm">
                https://posthog.com/web-analytics
              </a>
              .
            </p>
            <p className="mb-6 text-gray-700" data-id="element-685" data-mp="37ouzdsyh164w">
              <strong data-id="element-686" data-mp="3vfr0jgothdot">Do Not Track.</strong> Currently, the Website does not
              recognize "Do-Not-Track" requests. You may, however, disable
              certain tracking by disabling cookies.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-687" data-mp="206u0cx1wjdek">
              Third Party Privacy Policies
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-688" data-mp="1vcptedsmz5dh">
              The Website and Services may contain links to third-party sites or
              apps, or vice versa. This Privacy Policy does not apply to those
              third-party sites or apps. We recommend that you read the privacy
              statements of any other sites or apps that you visit, as we are
              not responsible for the privacy practices of those sites or apps.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-689" data-mp="294mfo17mil1y">
              Data Integration &amp; Third-Party Services
            </h3>

            <h4 className="text-lg font-semibold text-gray-800 mt-6 mb-2" data-id="element-690" data-mp="xqsfyut45q8e">
              Google API Disclosure
            </h4>
            <p className="mb-6 text-gray-700" data-id="element-691" data-mp="toxglvuqtmx9">
              Nisa's use and transfer of information received from Google APIs
              to any other app will adhere to the{' '}
              <a href="https://developers.google.com/terms/api-services-user-data-policy" className="text-primary-600 hover:text-primary-800" target="_blank" rel="noopener noreferrer" data-id="element-692" data-mp="39dukq8otxf4n">
                Google API Services User Data Policy
              </a>
              , including the Limited Use requirements.
            </p>

            <h4 className="text-lg font-semibold text-gray-800 mt-6 mb-2" data-id="element-693" data-mp="3o1yugn5wmgba">
              Google Drive Integration
            </h4>
            <p className="mb-6 text-gray-700" data-id="element-694" data-mp="3t0a53040wuuk">
              Nisa allows you to integrate your Google Drive account to
              streamline your coaching workflow.
            </p>

            <p className="mb-2 text-gray-700" data-id="element-695" data-mp="5wvkop4ztg4j">
              <strong data-id="element-696" data-mp="22pp41ewa4e8r">Information We Access.</strong> If you grant permission,
              Nisa will have "read-only" access to your Google Drive files
              (drive.readonly). This allows the application to view, search, and
              extract text from documents, presentations, and PDFs that you
              explicitly share with the Nisa AI assistant or search for within
              the chat interface.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-697" data-mp="1jdfjmaurpdn8">
              <strong data-id="element-698" data-mp="1jajikdnmi8uk">How We Use This Data.</strong> We use this access solely
              to provide AI-driven insights, summarize your meeting notes, or
              generate coaching supports based on your existing documents.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-699" data-mp="2gz3f8tjefrxp">
              <strong data-id="element-700" data-mp="2gxsbgtpyek6l">Data Retention.</strong> Content extracted from your
              Google Drive files is processed to generate AI responses. We do
              not use your Google Drive data to train generalized AI models.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-701" data-mp="rkyho055wi9h">
              <strong data-id="element-702" data-mp="rnb16hqkj0on">User Control.</strong> You can disconnect your Google
              Drive account at any time through the Nisa settings menu or by
              revoking access in your{' '}
              <a href="https://myaccount.google.com/permissions" className="text-primary-600 hover:text-primary-800" target="_blank" rel="noopener noreferrer" data-id="element-703" data-mp="o5djr0oerzay">
                Google Security settings
              </a>
              . Disconnecting will immediately terminate Nisa's ability to
              access your files.
            </p>

            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-704" data-mp="5c9mz6fw96c4">
              Your Privacy Choices
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-705" data-mp="f12gz79wq7p">
              We make available several ways for you to manage choices about
              your personal information, including preferences regarding cookies
              and whether you want to receive marketing and promotional emails
              from us, and choices regarding your account and profile
              information.
            </p>
            <p className="mb-2 text-gray-700" data-id="element-706" data-mp="3drjh9sdjl79c">
              <strong data-id="element-707" data-mp="3dqrxdetb4xyw">Cookie Settings.</strong> To prevent cookies from tracking
              your activity on the Website or visits across multiple websites,
              you can set your browser to block certain cookies or notify you
              when a cookie is set; you can also delete cookies. The "Help"
              portion of the toolbar on most browsers will tell you how to
              prevent your device from accepting new cookies, how to have the
              browser notify you when you receive a new cookie, or how to delete
              cookies. Visitors to the Website who disable cookies will be able
              to browse the Website, but some features may not function.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-708" data-mp="2bzq7p6acii9">
              <strong data-id="element-709" data-mp="2ducb6tamgnx">Marketing Communications.</strong>
            </p>
            <p className="mb-6 text-gray-700" data-id="element-710" data-mp="18t4nc51trllf">
              <strong data-id="element-711" data-mp="18uftgbiqt5fp">Email.</strong> You can opt out of receiving marketing
              emails from us by using the unsubscribe feature in any such email
              we send you.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-712" data-mp="2ybjoxt7sggfz">
              Children's Information
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-713" data-mp="2ojnpoetyuka6">
              The Website is not intended for individuals under the age of 18
              and the TLVI does not knowingly collect any personal information
              from children under the age of 13 without verifiable parental
              consent. If you think that your child provided this kind of
              information via the Website, we strongly encourage you to contact
              us immediately and we will use our best efforts to promptly remove
              such information from our records.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-714" data-mp="20nt1qm2cw0yo">
              International Users
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-715" data-mp="3uzzg1tqjqxv7">
              The Website and Services are solely intended for individuals
              located within the United States and its territories and are
              subject to U.S. law. If you are located outside of the United
              States and its territories, please do not use the Website and
              Services. By utilizing the Website and Services, you consent to
              the transfer of your data to the United States and its maintenance
              in the United States. Please be aware that the data protection
              laws in the United States may differ from those in your country of
              origin.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-716" data-mp="3ac07osnvksqy">
              Security
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-717" data-mp="3fabh52a9d18n">
              Information provided by or made accessible by you to us, including
              but not limited to personal information, to the extent maintained
              on our systems, is protected using reasonable steps to deter
              against the loss, misuse and alteration of the information to the
              extent under our control. Due to the nature of the Internet,
              computer networks, systems and other factors, we cannot guarantee
              that the information submitted to, maintained on, or transmitted
              from our systems or the Website will be completely secure. You are
              solely responsible for all data that you transmit or that relates
              to any activity you have undertaken using the Website and
              Services.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-718" data-mp="30mbcoxatra9k">
              Personal Data Retention
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-719" data-mp="3adfip7iivks9">
              We retain your personal information for as long as required to
              satisfy the purpose for which it was collected and used unless a
              longer period is necessary for our legal obligations or to defend
              a legal claim.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-720" data-mp="2h2iriwiek31r">
              Data Rights
            </h3>
            <p className="mb-6 text-gray-700" data-id="element-721" data-mp="2l3cdvlg759sj">
              While we are not currently subject to any comprehensive consumer
              privacy laws (such as the California Consumer Privacy Act or
              similar laws in other jurisdictions), we are committed to
              respecting your privacy and will honor reasonable requests to
              access, correct, know, or delete personal information that may be
              associated with your use of the Website and Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-722" data-mp="38qatkgwhsdpe">
              Please note that any such requests are subject to applicable
              contractual obligations we have with our business partners (such
              as schools, districts, or educational institutions). In some
              cases, we may be required to refer your request to the
              organization that provided you access to the Services.
            </p>
            <p className="mb-6 text-gray-700" data-id="element-723" data-mp="173hpat1swwec">
              To submit a request regarding your personal information, please
              contact us as described below. We may need to verify your identity
              and the nature of your relationship with the Website and Services
              before processing your request.
            </p>
            <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-724" data-mp="1usad2289rxxv">
              Contact Us
            </h3>
            <p className="mb-12 text-gray-700" data-id="element-725" data-mp="1puil587mkbto">
              If you have any questions about this Privacy Policy, please email
              us at{' '}
              <a href="mailto:privacy@nisa.coach" className="text-primary-600 hover:text-primary-800" data-id="element-726" data-mp="1gtkj2vgqyedq">
                privacy@nisa.coach
              </a>
              .
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-727" data-mp="5d2wro6v5s4t" />
    </div>;
};